module.exports = __webpack_public_path__ + "static/media/submit.761b03ec.svg";